import { ExpansionCardVariantIcon } from './ExpansionCardVariantIcon';

/**
 * author: Michael Richins
 * id A644DCA0-BDC5-480E-AA15-EFD1B1D4BDEB
 * name expansion-card-variant
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/expansion-card-variant.svg
 * tags
 */
export const NiceIcon = ExpansionCardVariantIcon;
export default NiceIcon